import { axios } from "@Root/API";

export const deleteUserToken = () => {
  return axios.delete("users/logout");
};
